import type { BackendRouteDefinition } from '../types';
import { withIdempotencyKeyHeader } from '../../../../../shared/backend/routes/idempotency';

export const submitPaymentFromClientToFirmRoute = {
  transport: 'api',
  method: 'POST',
  path: '/clients/payments',
  // The frontend contract already carries `idempotencyId` in the callable body.
  // Map that same value onto the API header so the wrapper signature stays
  // unchanged while the HTTP route can enforce mutation replay semantics.
  headers: ({ idempotencyId }: { idempotencyId: string }) =>
    withIdempotencyKeyHeader({ idempotencyKey: idempotencyId }),
} as const satisfies BackendRouteDefinition;
